import { render } from "./InvoiceList.vue?vue&type=template&id=373c1e3c&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"

import "./InvoiceList.vue?vue&type=style&index=0&id=373c1e3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373c1e3c"]])

export default __exports__